import React from 'react';
import { OverlayTrigger, Tooltip as BootstrapTooltip } from 'react-bootstrap';

const TooltipIcon = ({ icon, tooltip, classes, ...props }) => {
	return (
		<OverlayTrigger placement='top' overlay={<BootstrapTooltip>{tooltip}</BootstrapTooltip>}>
			<i {...props} className={`${icon} ${classes && classes}`} />
		</OverlayTrigger>
	);
};

export default TooltipIcon;
